import { useQuery } from "@tanstack/react-query";
import { assistantHistoryQueryKey } from "ai/hooks/constants";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
const fetchHistory = () => fetch("GET", qualifyUrl("/plugins/org.graylog.plugins.assistant/assistant"));
const useAssistantHistory = () => {
  const { data, refetch, isLoading } = useQuery({
    queryKey: assistantHistoryQueryKey,
    queryFn: fetchHistory
  });
  return { data, refetch, isLoading };
};
export default useAssistantHistory;
